import { Component, OnInit } from '@angular/core';
import { RelatorioDTO } from 'src/app/entity/relatorio/RelatorioDTO';
import { RelatorioService } from 'src/app/service/relatorio/relatorio.service';
import { ManifestoPorOperadorDTO } from 'src/app/entity/relatorio/manifestoPorOperador/ManifestoPorOperadorDTO';
import { FiltroManifestoPorOperadorDTO } from 'src/app/entity/relatorio/manifestoPorOperador/FiltroManifestoPorOperadorDTO';
import { ERRO_GERACAO_ARQUIVO } from 'src/app/tools/Mensagens';

const MAX_PAGE = 10;
const MAX_PAGINACAO = 5;

@Component({
  selector: 'manifesto-por-operador',
  templateUrl: './manifesto-por-operador.component.html',
  styleUrls: ['./manifesto-por-operador.component.css']
})
export class ManifestoPorOperadorComponent implements OnInit {

  count = 10;
  pages: Array<number>;
  filtro: FiltroManifestoPorOperadorDTO;
  relatorio: RelatorioDTO<ManifestoPorOperadorDTO>;
  listaUnidades: string[];
  MAX_PAGINACAO = MAX_PAGINACAO;

  constructor(private relatorioService: RelatorioService) {

    this.filtro = new FiltroManifestoPorOperadorDTO();

  }

  ngOnInit() {

    this.count = 10;
    //this.findAll(this.filtro);
    this.relatorio = new RelatorioDTO();
    this.relatorioService.listarUnidades()
    .subscribe((listaUnidades: string[]) => this.listaUnidades = listaUnidades,
    err => alert(err.error.message));

  }

  get paginacaoRegistros() {

    let maxPagina = (this.filtro.page + 1) * MAX_PAGE;

    if (maxPagina > this.relatorio.total) {

      maxPagina = this.relatorio.total;

    }

    return this.filtro.page * MAX_PAGE + 1 + ' - ' + maxPagina + ' de ' + this.relatorio.total + ' registros';

  }

  exibePagina(index) {

    return (index < (this.filtro.page + MAX_PAGINACAO) && (index >= this.filtro.page || index >= (this.pages.length - MAX_PAGINACAO))) ||
            (MAX_PAGINACAO > this.pages.length);

  }

  setFirstPage(event: any) {

    event.preventDefault();

    this.filtro.page = 0;
    this.findAll(this.filtro);

  }

  setLastPage(event: any) {

    event.preventDefault();

    this.filtro.page = this.relatorio.total % MAX_PAGE === 0 ?
                        this.relatorio.total / MAX_PAGE - 1 :
                        Math.trunc(this.relatorio.total / MAX_PAGE);
    this.findAll(this.filtro);

  }

  setNextPage(event: any) {

    event.preventDefault();

    if (this.filtro.page + 1 < this.pages.length) {

      this.filtro.page = this.filtro.page + 1;
      this.findAll(this.filtro);

    }

  }

  clean(event: any) {

    event.preventDefault();
    this.filtro = new FiltroManifestoPorOperadorDTO();
    this.findAll(this.filtro);

  }

  get filtroDesabilitado() {

    return !this.filtro.dataInicial || !this.filtro.dataFinal || this.filtro.dataInicial === 'null' || this.filtro.dataFinal === 'null';

  }

  gerarPdf() {

    this.relatorioService.gerarPdfManifestosPorOperador(this.filtro)
    .subscribe(pdf => {

      const blob = new Blob([pdf], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'arquivo.pdf';
      link.click();

    }, () => alert(ERRO_GERACAO_ARQUIVO));

  }

  gerarCsv() {

    this.relatorioService.gerarCsvManifestosPorOperador(this.filtro)
    .subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'arquivo.csv';
      link.click();

    }, err => alert(JSON.parse(err.error).message));

  }

  filter(event: any) {

    event.preventDefault();
    this.filtro.page = 0;
    this.count = 10;
    this.findAll(this.filtro);

  }

  setPreviousPage(event: any) {

    event.preventDefault();

    if (this.filtro.page > 0) {

      this.filtro.page = this.filtro.page - 1;
      this.findAll(this.filtro);

    }

  }

  setPage(i, event: any) {

    event.preventDefault();

    this.filtro.page = i;
    this.findAll(this.filtro);

  }

  findAll(filtro: FiltroManifestoPorOperadorDTO) {

    this.relatorioService.filtroRelatorioManifestosPorOperador(filtro)
    .subscribe((resultado: RelatorioDTO<ManifestoPorOperadorDTO>) => {

      this.relatorio.manifestos = resultado.manifestos;
      this.relatorio.total = resultado.total;
      this.relatorio.totalPaginado = resultado.totalPaginado;

      const totalPaginas = resultado.total % MAX_PAGE === 0 ? resultado.total / MAX_PAGE : Math.trunc(resultado.total / MAX_PAGE) + 1;
      this.pages = new Array(totalPaginas);

    }, err => alert(err.error.message));

  }

  dataHoraFormat(dataHora) {

    if (dataHora) {

      const m = new Date(dataHora);
      dataHora = ('0' + m.getUTCDate()).slice(-2) + '/' + ('0' + (m.getUTCMonth() + 1 )).slice(-2) + '/' + m.getUTCFullYear() + ' ' +
      ('0' + m.getUTCHours()).slice(-2) + ':' + ('0' + m.getUTCMinutes()).slice(-2) + ':' + ('0' + m.getUTCSeconds()).slice(-2);

    }

    return dataHora;

  }

  dataFormat(data) {

    if (data) {

      const m = new Date(data);
      data = ('0' + m.getUTCDate()).slice(-2) + '/' + ('0' + (m.getUTCMonth() + 1 )).slice(-2) + '/' + m.getUTCFullYear();

    }

    return data;

  }

}
